import { Injectable } from '@angular/core';
import { UserPreferenceKeysEnum } from '@shared/enums/user-preference-key.enum';
import { UserPreferences } from '@shared/interfaces/user-preferences.interface';
import { find, findIndex } from 'lodash';
import { UserApi } from '@core/api';

@Injectable({
    providedIn: 'root',
})
export class UserPreferencesService {
    private userPreferencesLocalStorageKey = 'userPreferences';
    private userPreferences!: UserPreferences;
    private currentUserId: string = '';

    constructor(private userApi: UserApi) {}

    setPreferences() {
        window.localStorage.setItem(this.userPreferencesLocalStorageKey, JSON.stringify(this.userPreferences));
    }

    getPreferenceValue(preferenceKey: UserPreferenceKeysEnum): string | undefined {
        return find(this.userPreferences?.preferences, preference => {
            return preference.key === preferenceKey;
        })?.value;
    }

    initializeUserPreferences(preferences: UserPreferences): void {
        this.currentUserId = preferences?.userId;

        if(!this.currentUserId) {
          return;
        }

        this.userPreferences = this.getUserPreferencesFromLocalStorage(this.currentUserId) ?? ({} as UserPreferences);
        if (!this.userPreferences.userId) {
            this.userPreferences = {
                userId: preferences.userId,
                preferences: preferences.preferences,
            };
        }

        this.setPreferences();
    }

    saveUserPreferencesToLocalStorage(newPreference: { key: UserPreferenceKeysEnum; value: string }): void {
        const indexOfPreference = findIndex(this.userPreferences.preferences, preference => {
            return preference.key === newPreference.key;
        });

        this.userApi.saveUserPreferences(newPreference);

        this.userPreferences.preferences[indexOfPreference] = newPreference;
        this.setPreferences();
    }

    getUserPreferencesFromLocalStorage(userId: string): UserPreferences | null {
        if (!userId) {
            return null;
        }

        const userPreferencesKey = window.localStorage.getItem(this.userPreferencesLocalStorageKey);
        if (!userPreferencesKey) {
            return null;
        } else {
            const userPreferences = JSON.parse(userPreferencesKey) as UserPreferences;
            if (userPreferences.userId != userId) {
                window.localStorage.removeItem(this.userPreferencesLocalStorageKey);
                return null;
            } else {
                return userPreferences;
            }
        }
    }
}
